import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './badge.module.scss';

const cx = classNames.bind(styles);

function Badge(props) {
  const {
    text,
    badgeType,
  } = props;

  const badgeClassName = cx({
    badge: true,
    badgePrimary: !badgeType || badgeType === 'primary',
    badgeSecondary: badgeType === 'secondary',
    badgeTertiary: badgeType === 'tertiary',
    badgeQuaternary: badgeType === 'quaternary',
  });

  return (
    <div className={badgeClassName}>
      <p className={styles.text}>{text}</p>
    </div>
  );
}

export default Badge;

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  badgeType: PropTypes.string,
};

Badge.defaultProps = {
  badgeType: 'primary',
};